import styles from './styles.module.scss';
import { useMedia } from 'react-use';
import { maxPhoneWidth, maxTabletWidth } from '../../../../../shared/widths';
import CloudsBg from '../../../../../assets/images/metro/CloudsBg.svg';
import CloudsBgMobile from '../../../../../assets/images/metro/CloudsBgMobile.svg';
import CloudsBgTablet from '../../../../../assets/images/metro/CloudsBgTablet.svg';

export const Clouds: React.FC = () => {
  const isPhone = useMedia(`(max-width: ${maxPhoneWidth}px)`, false);
  const isTablet = useMedia(`(max-width: ${maxTabletWidth}px)`, false);

  return (
    <div className={styles.wrapper}>
      <img src={isPhone ? CloudsBgMobile : isTablet ? CloudsBgTablet : CloudsBg} className={styles.clouds} />
    </div>
  );
};
